import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { Modal } from "react-bootstrap";
import { Map, TileLayer, Marker } from "react-leaflet";

import i18next from "i18next";

import config from "config";

import DeviceViewDetailsGraph from "./device_view_details_graph";

const DeviceDataGraphModal = ({ entityTypeToken, entityId, entityName, dataType, entity, timezone, show, onHide, singleSelectedMeasurement }) => {
    const [geoValue, setGeoValue] = useState(null);
    const [geoError, setGeoError] = useState(null);

    useEffect(() => {
        setGeoValue(null);
        if (dataType.token == "geo_lat_lon" || (dataType.deviceDataClassification && dataType.deviceDataClassification.token == "geo_position")) {
            if (entity.deviceLastReceivedData) {
                const complexValue = entity.deviceLastReceivedData.find((data) => (data.deviceDataType.id === dataType.id) || (data.deviceDataType.deviceDataClassification && dataType.deviceDataClassification && data.deviceDataType.deviceDataClassification.id === dataType.deviceDataClassification.id));
                if (complexValue && complexValue.complexValue && complexValue.complexValue.latitude && complexValue.complexValue.longitude) {
                    setGeoValue(complexValue.complexValue);
                } else {
                    setGeoError("No current value.");
                }
            } else {
                setGeoError("No current value.");
            }
        }
    }, [dataType]);

    const entityTypeName = dataType.token ? i18next.t(`device-data-types.${dataType.token}`) : (dataType.deviceDataClassification && dataType.deviceDataClassification.token ? i18next.t(`device-data-classifications.${dataType.deviceDataClassification.token}`) : '');

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <img src={`${config.WEB_BASE_URL}/images/icon/themes/${window.globalBrand}/charts.svg`} alt={i18next.t("data-chart")} /> {entityName} {entityTypeName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="device-chart-modal">
                {(dataType.token == "geo_lat_lon") || (dataType.deviceDataClassification && dataType.deviceDataClassification.token == "geo_position") ? (
                    geoValue && <GeoValueMap geoValue={geoValue} /> || geoError && <span>{geoError}</span>
                ) : (
                    <DeviceViewDetailsGraph 
                        key={dataType.id} 
                        dataType={dataType} 
                        singleSelectedMeasurement={singleSelectedMeasurement}
                        entity={entity}
                        entityTypeToken={entityTypeToken} 
                        entityId={entityId} 
                        timezone={timezone} 
                    />
                )}
            </Modal.Body>
        </Modal>
    );
};

DeviceDataGraphModal.propTypes = {
  entityTypeToken: PropTypes.string.isRequired,
  entityId: PropTypes.number.isRequired,
  entityName: PropTypes.string.isRequired,
  dataType: PropTypes.object.isRequired,
  entity: PropTypes.object.isRequired,
  timezone: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired
};

const GeoValueMap = ({ geoValue }) => {
    if (geoValue == null) {
        return <div>Location unavailable</div>;
    } else {
        return (
            <Map id="mapId" center={[geoValue.latitude, geoValue.longitude]} zoom={12}>
                <TileLayer attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" />
                <Marker position={[geoValue.latitude, geoValue.longitude]} />
            </Map>
        );
    }
};

GeoValueMap.propTypes = {
  geoValue: PropTypes.object.isRequired
};

export default DeviceDataGraphModal;
